import React from 'react'
import './HeaderLink.css'
import { Link } from "react-router-dom";

export const HeaderLink = ({ title, icon = null, url, active = false, children, className = '', ...props }) => (
  <Link to={url} className={`HeaderLink ${active && 'HeaderLink--active'} ${className}`} {...props}>
    {children}
    {title}
  </Link>
)